// ============================================================================
// 📁 CustomFieldsBlock.js  — SAFE version (auto-normalizes backend data)
// ============================================================================

import React from "react";

export default function CustomFieldsBlock({ customFields }) {
  if (!customFields) return null;

  let normalized = [];

  // -----------------------------
  // CASE 1 — Backend sends object:
  // { "Field1": "Value1", "Field2": "Value2" }
  // -----------------------------
  if (typeof customFields === "object" && !Array.isArray(customFields)) {
    normalized = Object.entries(customFields).map(([label, value]) => ({
      label,
      value,
    }));
  }

  // -----------------------------
  // CASE 2 — Backend already sends array
  // -----------------------------
  else if (Array.isArray(customFields)) {
    normalized = customFields.map((item) => ({
      label: item.label || item.name || item.key || "Field",
      value: item.value || item.val || item.data || "-",
    }));
  }

  // If still empty → return nothing
  if (normalized.length === 0) return null;

  return (
    <div
      className="tf-block"
      style={{
        background: "#fff",
        padding: "20px 24px",
        borderRadius: "14px",
        marginBottom: "22px",
        border: "1px solid #eee",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#2a2344",
          marginBottom: "14px",
        }}
      >
        Custom Fields
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "16px",
        }}
      >
        {normalized.map((field, index) => (
          <div
            key={index}
            style={{
              background: "#faf7ff",
              borderRadius: "10px",
              padding: "12px 16px",
              border: "1px solid #e8ddff",
            }}
          >
            <div style={{ fontSize: "13px", opacity: 0.6 }}>
              {field.label}
            </div>

            <div
              style={{
                fontSize: "15px",
                marginTop: "4px",
                fontWeight: 600,
                color: "#3a2768",
              }}
            >
              {field.value || "-"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
